import React, { useRef } from "react";
import { ChevronRight, ChevronLeft, ExternalLink } from "react-feather";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import Link from "next/link";

const BestList = ({ linkData = [] }) => {
  const { t } = useTranslation();
  const containerRef = useRef(null);

  const scroll = (dir) => {
    if (containerRef.current)
      containerRef.current.scrollLeft += dir === "next" ? 300 : -300;
  };

  if (!linkData.length) return null;

  return (
    <section style={{ background: "#fff", padding: "80px 0" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 40 }}>
          <div>
            <div style={{
              display: "inline-flex", alignItems: "center", gap: 8,
              background: "#EFF6FF", borderRadius: 100, padding: "6px 16px", marginBottom: 12,
            }}>
              <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#0047AB" }} />
              <span style={{ fontSize: 13, fontWeight: 600, color: "#0047AB", textTransform: "uppercase", letterSpacing: "0.04em" }}>
                Хамтын ажиллагаа
              </span>
            </div>
            <h2 style={{
              fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)",
              fontWeight: 800, color: "#0A0F1E", margin: 0,
              fontFamily: "'Outfit', 'Inter', sans-serif",
            }}>
              Хамтрагч байгууллагууд
            </h2>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {[{ dir: "prev", Icon: ChevronLeft }, { dir: "next", Icon: ChevronRight }].map(({ dir, Icon }) => (
              <button key={dir} onClick={() => scroll(dir)} style={{
                width: 40, height: 40,
                background: "#fff", border: "1px solid #E2E8F0",
                borderRadius: 10, cursor: "pointer",
                display: "flex", alignItems: "center", justifyContent: "center",
                transition: "all 0.2s",
                color: "#0047AB",
              }}
                onMouseEnter={e => { e.currentTarget.style.background = "#EFF6FF"; e.currentTarget.style.borderColor = "#0047AB"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#E2E8F0"; }}
              >
                <Icon size={18} />
              </button>
            ))}
          </div>
        </div>

        {/* Scrollable list */}
        <div style={{ position: "relative" }}>
          <div
            ref={containerRef}
            style={{
              display: "flex", gap: 20, overflowX: "auto",
              scrollBehavior: "smooth",
              scrollbarWidth: "none", msOverflowStyle: "none",
              paddingBottom: 4,
            }}
            className="scrollbar-hidden"
          >
            {linkData.map((item, i) => (
              <Link key={item.id || i} href={item.link || "#"} passHref target="_blank" rel="noopener noreferrer">
                <PartnerCard item={item} />
              </Link>
            ))}
          </div>
          {/* Fade edges */}
          <div style={{
            position: "absolute", right: 0, top: 0, bottom: 0, width: 60,
            background: "linear-gradient(to right, transparent, #fff)",
            pointerEvents: "none",
          }} />
        </div>
      </div>
    </section>
  );
};

const PartnerCard = ({ item }) => {
  const [hover, setHover] = React.useState(false);
  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        flexShrink: 0, width: 220,
        background: "#fff",
        border: "1px solid",
        borderColor: hover ? "#0047AB" : "#E2E8F0",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: hover ? "0 12px 32px rgba(0,71,171,0.12)" : "0 2px 8px rgba(0,0,0,0.05)",
        transform: hover ? "translateY(-4px)" : "none",
        transition: "all 0.3s cubic-bezier(0.4,0,0.2,1)",
        cursor: "pointer",
      }}
    >
      {/* Logo area */}
      <div style={{
        height: 140, padding: 20,
        display: "flex", alignItems: "center", justifyContent: "center",
        background: "#F8FAFC",
      }}>
        <div style={{
          width: "100%", height: "100%",
          backgroundImage: `url(${item.imageUrl})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: hover ? "none" : "grayscale(20%)",
          transition: "filter 0.3s",
        }} />
      </div>
      {/* Name */}
      <div style={{
        padding: "12px 16px",
        borderTop: "1px solid #F1F5F9",
        display: "flex", alignItems: "center", justifyContent: "space-between",
        gap: 8,
      }}>
        <span style={{
          fontSize: 12, fontWeight: 600, color: hover ? "#0047AB" : "#334155",
          overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
          transition: "color 0.2s",
        }}>
          {i18n.language === "en" ? item.descriptionEng : item.description}
        </span>
        <ExternalLink size={12} color={hover ? "#0047AB" : "#94A3B8"} style={{ flexShrink: 0, transition: "color 0.2s" }} />
      </div>
    </div>
  );
};

export default BestList;
